import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["searchable", "autoAlign", "autoFocusSearch", "popoverWidth", "popoverClassName", "zIndex", "emptyRender", "emptyContent", "searchPlaceholder", "onSearchChange", "value", "disabled", "readonly", "filterOption", "placement", "autoClearSearchValue", "children", "renderSelected", "placeholder", "onValueChange", "loading", "renderLoading", "renderFooter", "show", "onHide", "onShow", "onVisibleChange", "defaultShow", "alwayRenderSelected", "maxTagCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file MultipleSelect.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import { ViewSelectTrigger } from '../../views/ViewSelectTrigger';
import { Tag } from '../Tag';
import { MultipleSelectContainer } from './MultipleSelectContainer';
import { useRefFunction } from '@tencent/glue-react-use';
import { SELECT_MAX_COUNT_NODE_KEY, getDisplayItems } from './util';
var defaultTagStyle = {
  display: 'flex',
  alignItems: 'center',
  margin: '2px 4px 2px 0',
  overflow: 'hidden'
};

var getSelected = function getSelected(props) {
  var displayItem = props.displayItem,
      renderSelected = props.renderSelected,
      value = props.value,
      onValueChange = props.onValueChange,
      maxTagCount = props.maxTagCount;
  var nextDisplayItems = getDisplayItems({
    displayItems: displayItem,
    maxTagCount: maxTagCount
  });

  if (renderSelected) {
    return renderSelected(nextDisplayItems);
  }

  var closeHandle = function closeHandle(e, val) {
    e.stopPropagation();
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(value === null || value === void 0 ? void 0 : value.filter(function (item) {
      return item !== val;
    }));
  };

  return nextDisplayItems.map(function (item) {
    return React.createElement("div", {
      style: _objectSpread(_objectSpread({}, defaultTagStyle), {}, {
        flexShrink: item.value === SELECT_MAX_COUNT_NODE_KEY ? 0 : 1
      })
    }, React.createElement(Tag, {
      size: "sm",
      style: {
        fontSize: 12
      },
      closable: item.value !== SELECT_MAX_COUNT_NODE_KEY,
      onClose: function onClose(e) {
        return closeHandle(e, item.value);
      }
    }, item.label));
  });
};

export var MultipleSelect = function MultipleSelect(props) {
  var searchable = props.searchable,
      autoAlign = props.autoAlign,
      autoFocusSearch = props.autoFocusSearch,
      popoverWidth = props.popoverWidth,
      popoverClassName = props.popoverClassName,
      zIndex = props.zIndex,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      searchPlaceholder = props.searchPlaceholder,
      onSearchChange = props.onSearchChange,
      value = props.value,
      disabled = props.disabled,
      readonly = props.readonly,
      filterOption = props.filterOption,
      placement = props.placement,
      autoClearSearchValue = props.autoClearSearchValue,
      children = props.children,
      renderSelected = props.renderSelected,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '请选择' : _props$placeholder,
      onValueChange = props.onValueChange,
      loading = props.loading,
      renderLoading = props.renderLoading,
      renderFooter = props.renderFooter,
      show = props.show,
      onHide = props.onHide,
      onShow = props.onShow,
      onVisibleChange = props.onVisibleChange,
      defaultShow = props.defaultShow,
      alwayRenderSelected = props.alwayRenderSelected,
      maxTagCount = props.maxTagCount,
      extra = _objectWithoutProperties(props, _excluded);

  var container = {
    searchable: searchable,
    autoAlign: autoAlign,
    autoFocusSearch: autoFocusSearch,
    popoverWidth: popoverWidth,
    emptyRender: emptyRender,
    emptyContent: emptyContent,
    searchPlaceholder: searchPlaceholder,
    onSearchChange: onSearchChange,
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    readonly: readonly,
    filterOption: filterOption,
    placement: placement,
    autoClearSearchValue: autoClearSearchValue,
    children: children,
    loading: loading,
    renderLoading: renderLoading,
    renderFooter: renderFooter,
    show: show,
    onHide: onHide,
    onShow: onShow,
    onVisibleChange: onVisibleChange,
    popoverClassName: popoverClassName,
    zIndex: zIndex,
    defaultShow: defaultShow
  };
  var getSelectedValue = useRefFunction(function (display) {
    if (display === null || display === void 0 ? void 0 : display.length) {
      return getSelected({
        displayItem: display,
        renderSelected: renderSelected,
        value: value,
        onValueChange: onValueChange,
        maxTagCount: maxTagCount
      });
    }

    if (alwayRenderSelected) {
      return getSelected({
        displayItem: [],
        renderSelected: renderSelected,
        value: value,
        onValueChange: onValueChange,
        maxTagCount: maxTagCount
      });
    }

    return placeholder;
  });

  var renderTrigger = function renderTrigger(ref, show, display) {
    return React.createElement(ViewSelectTrigger, _objectSpread(_objectSpread({}, extra), {}, {
      elRef: ref,
      multiple: true,
      disabled: disabled,
      show: show,
      empty: !(display === null || display === void 0 ? void 0 : display.length),
      responsive: maxTagCount === 'responsive'
    }), getSelectedValue(display));
  };

  return React.createElement(MultipleSelectContainer, _objectSpread({
    renderTrigger: renderTrigger
  }, container));
};